

import React, { useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from 'react-router-dom';
import { options } from '../data/nav'
import Page from "../app/services/pageCopy";
import CustomNavbar from "../components/CustomNavbar";
import FooterData from "../components/Footer/FooterData";
import FooterTwo from "../components/Footer/FooterTwo";

const Service = () => {
    const serviceRef = useRef(null);
    const onClickService = () => {
        serviceRef.current.scrollIntoView({ behavior: "smooth" });
    }
    const params = useParams();
    const serviceSlug = params.slug;
    const details = options.filter((title) => title.href === serviceSlug);
    console.log(details, '>>>>>>>>>')
    return (
        <>
            <main className="main-wrapper">
                <CustomNavbar
                    nClass="m-auto"
                    hbtnClass="new_btn"
                />
                <Page />
                <FooterTwo FooterData={FooterData} onClickService={onClickService} />

            </main>
        </>
    );
};

export default Service;